import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { LoanComputationService } from '../../service/loan-computation.service';
import { MyHomeState } from '../../state/my-home.state';
import { CreateRefinanceMortgageScenarioDialogComponent } from '../create-refinance-mortgage-scenario-dialog/create-refinance-mortgage-senerio-dialog.component';

@Component({
  selector: 'app-refinance-mortgage',
  templateUrl: './refinance-mortgage.component.html',
  styleUrls: ['./refinance-mortgage.component.scss'],
})
export class RefinanceMortgageComponent implements OnInit {
  constructor(
    private myHomeState: MyHomeState,
    private loanComputationService: LoanComputationService,
    private dialog: MatDialog
  ) { }
  @Input() mortgage;
  originalMortgageComputedLoan: any;
  computedLoan: any;
  deleteLoan = false;
  current = true;
  ngOnInit(): void { }

  ngOnChanges() {
    this.originalMortgageComputedLoan = this.loanComputationService.computeTotalLoan(
      this.mortgage.principal,
      this.mortgage.interest / 100,
      this.mortgage.term,
      new Date(this.mortgage.startDate)
    );
    this.computedLoan = this.originalMortgageComputedLoan;
    if (this.mortgage?.refinanceScenarioList && this.mortgage?.refinanceScenarioList.length > 1) {
      this.deleteLoan = true;
    } else {
      this.deleteLoan = false;
    }
    if (this.mortgage?.refinanceScenarioList && this.mortgage?.refinanceScenarioList.length >= 1) {
      for (const obj of this.mortgage?.refinanceScenarioList) {
        if (obj?.isActive == true) {
          this.current = false;
          return;
        }
      }
    }
  }

  CreateNewLoan() {
    this.dialog.open(CreateRefinanceMortgageScenarioDialogComponent, {
      width: '385px',
      disableClose: true,
      data: { currentBalance: this.mortgage?.principalBalance, selectedMortgage: this.mortgage?.id, selectedMortgageData: this.mortgage },
    });
  }

  selectedChange(event, isCurrent?) {
    let myHomeValues = this.myHomeState.myHomeListValue.filter((myHome) => {
      return myHome.id == this.myHomeState.activeHomeValue.id;
    });
    myHomeValues = myHomeValues[0];
    myHomeValues.mortgageList.map((mortgage) => {
      if (mortgage.id === this.mortgage.id) {
        if (event.option === 'delete' || event.option == 'active')
          mortgage.refinanceScenarioList = mortgage.refinanceScenarioList.filter((element: any) => {
            if (element.id !== event.loanId && event.option == 'delete') {
              return element;
            }
            if (event.option == 'active') {
              if (element.id == event.loanId && !isCurrent) {
                element.isActive = true;
                return element;
              }
              if (isCurrent) {
                element.isActive = false;
                return element;
              } else {
                element.isActive = false;
                return element;
              }
            }
          });
        else {
          mortgage.refinanceScenarioList.map((element: any) => {
            if (element.id == event.loanId && event.option == 'update') {
              if (event.updatekey == 'closeByYearsInput') {
                element.termBalance = event.changeValue * 12;
              }
              if (event.updatekey == 'interestRateInput') {
                element.interestRate = event.changeValue;
              }
              if (event.updatekey == 'closingCostInput') {
                element.closingCost = event.changeValue;
              }
            }
          });
        }
      }
    });
    this.myHomeState.homeListUpdateValue = myHomeValues;

    for (const obj of this.mortgage?.refinanceScenarioList) {
      if (obj.isActive == true) {
        this.current = false;
        return;
      }
    }
  }
}
